/* Mezkla header — vanilla JS for the split navbar.
   Handles: mega-menu hover (with 100ms cursor-bridging close delay),
   language pill toggle, and mobile hamburger open/close.
   No framework, no dependencies. Runs once per page load.
*/
(function () {
  'use strict';

  var header = document.querySelector('[data-mezkla-header]');
  if (!header) return;

  /* ─── Mega menu ────────────────────────────────────────────────────── */
  var triggers = header.querySelectorAll('[data-mega-trigger]');
  var panels = header.querySelectorAll('[data-mega-panel]');
  var closeTimer = null;
  var activeVariant = null;

  function showPanel(variant) {
    activeVariant = variant;
    panels.forEach(function (p) {
      var match = p.getAttribute('data-mega-panel') === variant;
      p.hidden = !match;
      if (match) {
        // Restart the fadeSlideDown animation on every open.
        p.style.animation = 'none';
        // Force reflow so the animation actually re-runs.
        void p.offsetWidth;
        p.style.animation = '';
      }
    });
    triggers.forEach(function (t) {
      var isActive = t.getAttribute('data-mega-trigger') === variant;
      t.setAttribute('aria-expanded', isActive ? 'true' : 'false');
    });
  }

  function hidePanels() {
    activeVariant = null;
    panels.forEach(function (p) { p.hidden = true; });
    triggers.forEach(function (t) { t.setAttribute('aria-expanded', 'false'); });
  }

  function scheduleClose() {
    cancelClose();
    closeTimer = window.setTimeout(hidePanels, 100);
  }

  function cancelClose() {
    if (closeTimer) {
      window.clearTimeout(closeTimer);
      closeTimer = null;
    }
  }

  triggers.forEach(function (trigger) {
    var variant = trigger.getAttribute('data-mega-trigger');
    trigger.addEventListener('mouseenter', function () {
      cancelClose();
      showPanel(variant);
    });
    trigger.addEventListener('mouseleave', scheduleClose);
    trigger.addEventListener('focus', function () {
      cancelClose();
      showPanel(variant);
    });
  });

  panels.forEach(function (panel) {
    panel.addEventListener('mouseenter', cancelClose);
    panel.addEventListener('mouseleave', scheduleClose);
    // Any click inside a panel (i.e. a link) should dismiss the menu.
    panel.addEventListener('click', function (e) {
      if (e.target.closest('a')) hidePanels();
    });
  });

  // Esc closes the menu.
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && activeVariant) hidePanels();
  });

  /* ─── Mobile menu (slide-in panel from left) ──────────────────────── */
  var mobileMenu = header.querySelector('[data-mobile-menu]');
  var hamburger = header.querySelector('[data-hamburger]');
  var mobileClose = header.querySelector('[data-mobile-menu-close]');
  var mobileBackdrop = header.querySelector('[data-mobile-menu-backdrop]');
  var mobileMenuLastFocused = null;

  function openMobileMenu() {
    if (!mobileMenu) return;
    mobileMenuLastFocused = document.activeElement;
    mobileMenu.removeAttribute('hidden');
    // Force reflow so the [hidden]→visible state paints before data-open
    void mobileMenu.offsetWidth;
    mobileMenu.setAttribute('data-open', 'true');
    document.body.style.overflow = 'hidden';
    // Body class lets CSS raise the header above the announcement bar —
    // the mobile menu sits inside the header element so it can't escape
    // the header's stacking context (z-index: 30) on its own.
    document.body.classList.add('mobile-menu-open');
    if (hamburger) hamburger.setAttribute('aria-expanded', 'true');
    if (mobileClose) mobileClose.focus();
  }

  function closeMobileMenu() {
    if (!mobileMenu) return;
    mobileMenu.setAttribute('data-open', 'false');
    document.body.style.overflow = '';
    document.body.classList.remove('mobile-menu-open');
    if (hamburger) hamburger.setAttribute('aria-expanded', 'false');
    // Wait for the slide-out transition before fully hiding.
    window.setTimeout(function () {
      mobileMenu.setAttribute('hidden', '');
      if (mobileMenuLastFocused && typeof mobileMenuLastFocused.focus === 'function') {
        mobileMenuLastFocused.focus();
      }
    }, 300);
  }

  if (hamburger) {
    hamburger.addEventListener('click', function () {
      var isOpen = hamburger.getAttribute('aria-expanded') === 'true';
      if (isOpen) closeMobileMenu();
      else openMobileMenu();
    });
  }
  if (mobileClose) mobileClose.addEventListener('click', closeMobileMenu);
  if (mobileBackdrop) mobileBackdrop.addEventListener('click', closeMobileMenu);

  // Esc closes the mobile menu (separate from the mega-menu Esc handler above).
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && mobileMenu && mobileMenu.getAttribute('data-open') === 'true') {
      closeMobileMenu();
    }
  });

  // Clicking a nav link closes the menu (after letting the link navigate).
  // The lang button is also inside the panel — exclude it from auto-close.
  if (mobileMenu) {
    mobileMenu.addEventListener('click', function (e) {
      var link = e.target.closest('a');
      if (link) closeMobileMenu();
    });
  }
})();
